import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { adminGetDashboardAppRevenueDataApi } from '../../../api/dashboard/adminGetDashboardAppRevenueDataApi';
import {
  AdminDashboardAppRevenueFilter,
  AdminDashboardAppRevenueResponse,
} from '../../../graphql/API';

export const useAdminGetDashboardAppRevenueDataQuery = (
  filter: AdminDashboardAppRevenueFilter,
): UseQueryResult<AdminDashboardAppRevenueResponse, Error> => {
  const adminGetDashboardAppRevenueDataQuery = useQuery({
    queryKey: ['admin-get-dashboard-app-revenue-data', filter],
    queryFn: async ({ queryKey }) => {
      const [, filter] = queryKey as [string, AdminDashboardAppRevenueFilter];
      const response = await adminGetDashboardAppRevenueDataApi(filter);
      return response;
    },
    enabled: !!filter.fromDate && !!filter.toDate && !!filter.platform,
  });
  return { ...adminGetDashboardAppRevenueDataQuery };
};